var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 19C15.0004 19.7957 14.6843 20.5587 14.1217 21.1213C13.5591 21.6839 12.796 22 12.0004 22C11.2047 22 10.4416 21.6839 9.87903 21.1213C9.31642 20.5587 9.00035 19.7957 9.00035 19M12.7214 5.00302L11.2554 5.00002C7.91135 4.99202 5.00835 7.70902 4.98535 11V14.79C4.98535 15.58 4.88535 16.351 4.45435 17.008L4.16735 17.446C3.73035 18.11 4.20035 19 4.98535 19H19.0154C19.8004 19 20.2694 18.11 19.8334 17.446L19.5464 17.008C19.1164 16.351 19.0154 15.579 19.0154 14.789V11.001C18.9754 7.70902 16.0654 5.01102 12.7214 5.00302Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V5H10V4C10 3.46957 10.2107 2.96086 10.5858 2.58579C10.9609 2.21071 11.4696 2 12 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.cd15f0fbec39c44afeb906d0d1ef4b0e.svg";
export { ForwardRef as ReactComponent };